import { verify } from '@/epp/expertmain/common/js/verify'
import { notification } from 'ant-design-vue'

//检验抽取人数
const checkExpertNumber = (rule, value, callback) => {
  if (value) {
    if (parseInt(value) % 2 === 0) {
      // callback(new Error('总人数必须为奇数，请修改!'))
      callback()
    } else {
      callback()
    }
  } else {
    callback()
  }
}
//校验规则
export const rules = {
  processUserId: [{ required: true, message: '处理人不能为空！', trigger: 'change' }],
  expertNumber: [{
    required: true,
    message: '专家人数不能为空！(填写采购品目后会自动计算)',
    trigger: 'change'
  }, { validator: checkExpertNumber }],
  addDate: [{ required: true, message: '登记时间不能为空！', trigger: 'change' }],
  setOfAddress: [{ required: true, message: '集合地点不能为空！', trigger: 'change' }, {
    max: 30,
    message: '集合地点输入最多30个字',
    trigger: 'change'
  }],
  applyTypeOther: [{ required: true, message: '其他用途不能为空！', trigger: 'change' }, {
    max: 35,
    message: '其他用途输入最多35个字',
    trigger: 'change'
  }],
  projectCode: [{ required: true, message: '招标编号不能为空！', trigger: 'change' }],
  reviewTelephone: [{ required: true, message: '咨询电话不能为空！', trigger: 'change' }, {
    max: 15,
    message: '咨询电话输入最多15个字',
    trigger: 'change'
  }, { pattern: '^(\\d+(-\\d+)+|\\d+)$', message: '咨询电话格式不对', trigger: 'change' }],
  information: [{ required: true, message: '携带材料不能为空！', trigger: 'change' }, {
    max: 35,
    message: '携带材料输入最多35个字',
    trigger: 'change'
  }],
  reviewDuration: [{ required: true, message: '预计评审持续时长不能为空！', trigger: 'change' }],
  applyType: [{ required: true, message: '申请用途不能为空！', trigger: 'change' }],
  expertName: [{
    min: 1,
    max: 10,
    pattern: verify.pattern_Chinese,
    message: '姓名有误！长度应在2~10个中文',
    trigger: 'blur'
  }],
  projectName: [{
    min: 1,
    max: 150,
    required: true,
    whitespace: true,
    message: '项目名称不能为空！最多150个字符',
    trigger: 'blur'
  }],
  applyUserName: [{ required: true, message: '申请人不能为空！', trigger: 'change' }],
}

/**
 *
 * @param e 错误信息
 * @param isNotErr 不是错误，不需要提醒
 */
export const formWaring = (e, isNotErr = false) => {
  if (isNotErr) {
    return
  }
  notification.warning({
    message: '保存失败',
    description: Object.keys(e)
      .map(key => e[key][0].message)
      .join('\n'),
    style: {
      whiteSpace: 'pre-wrap'
    }
  })
}
/**
 * 抽取状态
 */
export const ExtractStateEnum = {
  //系统抽取
  EXTRACT: '1',
  // 指定
  APPOINT: '2'
}
/**
 * 抽取记录表状态
 * @type {{getValOrCol(*): {color: (*|string), value: (*|string)}, NORMAL: string[], REDRAW: string[]}}
 */
export const ExtractRecordLevelEnum = {
  //正常抽取 指 人工抽取 或者系统抽取 第一次抽
  NORMAL: ['0', '正常抽取', 'green'],
  // 补抽
  REDRAW: ['1', '补抽', 'red'],
  getValOrCol (flag) {
    return getVal(flag, ExtractRecordLevelEnum)
  }
}

/**
 * 抽取后专家状态
 * @type {{getValue(*): *|string, BUSY: string[], LEAVE: string[], AVOID: string[], getColor(*): *|string, ABSENCE: string[], ATTEND: string[], IVR_FAIL: string[], EXTRACT: string[]}}
 */
export const ExtractExpertFlagEnum = {
  // 抽取
  EXTRACT: ['0', '等待反馈', ''],
  //参加
  ATTEND: ['1', '同意参加', 'green'],
  //不参加
  BUSY: ['2', '不参加', '#EE822F'],
  // 请假
  LEAVE: ['3', '请假', 'red'],
  //回避
  AVOID: ['4', '回避', 'red'],
  //缺席
  ABSENCE: ['5', '缺席', 'red'],

  getValOrCol (flag) {
    return getVal(flag, ExtractExpertFlagEnum)
  },

  getNotInFlagVal (flag) {
    return getNotInFlag(flag, ExtractExpertFlagEnum)
  }

}
/**
 * 语音呼叫状态
 * @type {{SUCCESS_CALL_END: string[], NO_CALL_OUT: string[], FAIL_CALL_OUT: string[], SUCCESS_CALL_OUT: string[]}}
 */
export const CallStateEnum = {
  NO_CALL_OUT: ['0', '未发起呼叫'],
  SUCCESS_CALL_OUT: ['1', '已发起呼叫语音'],
  FAIL_CALL_OUT: ['2', '语音呼叫失败'],
  SUCCESS_CALL_END: ['3', '语音已结束'],
}

/**
 * 短信发送状态
 * @type {{getValue(*): *|string, BUSY: string[], getColor(*): *|string, ATTEND: string[], EXTRACT: string[]}}
 */
export const ExtractExpertSmsEnum = {
  // 未发送
  SMS_NO_SEND: ['0', '未发送', 'red'],
  //成功发送
  SMS_SUCCESS: ['1', '成功发送', 'green'],
  //正在发送
  SMS_DOING_SEND: ['3', '发送中', 'blue'],
  //发送失败
  SMS_FAIL: ['2', '发送失败', 'red'],
  getValOrCol (flag) {
    return getVal(flag, ExtractExpertSmsEnum)
  }

}

/**
 * 获取对应的值和颜色
 * @param flag key值
 * @param enumE 参数对象
 * @returns {{color: (*|string), value: (*|string)}}
 */
export const getVal = (flag, enumE) => {
  let val = Object.keys(enumE).filter(item => enumE[item][0] === flag
  )[0]
  return {
    value: val ? enumE[val][1] : '未知状态',
    color: val ? enumE[val][2] : 'red'
  }
}

/**
 * 获取对应的值和颜色
 * @param flag key值
 * @param enumE 参数对象
 * @returns {{color: (*|string), value: (*|string)}}
 */
const getNotInFlag = (flag, enumE) => {
  let val = Object.keys(enumE).filter(item => {
    // 检查是否为函数，且第一个元素不等于 flag
    const value = enumE[item]
    return typeof value !== 'function' && value[0] !== flag
  })
  return (val ? val.map(key => enumE[key][0]).join(',') : '')
}

/**
 * 申请表审批状态
 */
export const ApplyStateEnum = {
  STATE_1: '1',//审核中
  STATE_2: '2',//已审核
}
/**
 * 解密状态
 * @type {{NO_DECRYPT: string[]}}
 */
export const DecryptFlagEnum = {
  // 未解密
  NO_DECRYPT: ['0', '未解密', 'red'],
  //成功发送
  YES_DECRYPT: ['1', '已解密', 'green'],
  getValOrCol (flag) {
    return getVal(flag, DecryptFlagEnum)
  }
}

/**
 * 申请用途
 * @type {{OTHER: string, PROJECT_REVIEW: string, PROJECT_ARGU: string}}
 */
export const ApplyTypeEnum = {
  //1项目评审 2项目论证 3其他
  PROJECT_REVIEW: '1',
  PROJECT_ARGU: '2',
  OTHER: '3'
}

/**
 * 截取区域，只显示市级
 * @param location
 * @returns {*|string}
 * @constructor
 */
export const GetCityFromLocation = (location) => {
  const parts = location.split(' / ')
  return parts.length > 1 ? parts[1].trim() : ''
}

export const TipsMessage = (that, msgType, msg) => {
  that[msgType]({
    title: '提示',
    content: msg
  })
}

/**
 * 短信供应商
 * @type {{cti: string, aliYun: string}}
 */
export const SMS_VENDOR_MAP = {
  aliYun: '阿里大于-企业V2',
  cti: '联通短信'
}

